import React from 'react';
import tomPortrait from '../../assets/illustrations/delay-saving-tom.webp';
import kenPortrait from '../../assets/illustrations/delay-saving-ken.webp';

// Decorative portraits: the adjacent names and descriptions identify each person.
const Portrait = ({ src, size }: { src: string; size: number }) => (
  <img className="dsc-character" src={src} alt="" width={size} height={size} decoding="async" draggable={false} />
);

export const Tom = ({ size = 72 }: { size?: number }) => <Portrait src={tomPortrait} size={size} />;
export const Ken = ({ size = 72 }: { size?: number }) => <Portrait src={kenPortrait} size={size} />;
